import { Component, OnInit } from '@angular/core';
import { PILOT_MODE_BANNER_DISMISSED_KEY } from '@app-core/constants/constants';
import { PreferencesResponse } from '@app-core/models/core.model';
import { DataService } from '@app-core/services/data/data.service';
import { StorageService } from '@app-core/services/storage/storage.service';

@Component({
  selector: 'app-notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrls: ['./notification-banner.component.scss'],
})
export class NotificationBannerComponent implements OnInit {
  public showBanner: boolean;
  public showEnabledBanner: boolean;
  public daysRemaining?: number;
  public formattedDate?: string;
  public showDisabledBanner: boolean;
  public showExpireBanner: boolean;
  constructor(public dataService: DataService, private storageService: StorageService) {}

  ngOnInit(): void {
    this.getFleetDetails();
  }

  public dismissBanner() {
    this.showBanner = false;
    this.storageService.setStorageValue(PILOT_MODE_BANNER_DISMISSED_KEY, this.bannerDismissalId);
  }

  public getFleetDetails() {
    this.dataService.getFleetDetails().subscribe({
      next: (res: PreferencesResponse) => {
        if (res?.pilotModeConfiguration?.isEnabled) {
          this.showBanner = true;
          this.showEnabledBanner = res?.pilotModeConfiguration?.isEnabled;
          this.getExpiryDateAndDays(res?.pilotModeConfiguration?.expiryDateUTC);
        }

        if (this.checkPilotModeExpiry(res?.pilotModeConfiguration?.expiryDateUTC)) {
          this.showBanner = false;
        }

        if (res?.pilotModeConfiguration?.isEnabled === false) {
          this.showBanner = true;
          this.showDisabledBanner = true;
        }

        if (this.showBanner && this.storageService.getStorageValue(PILOT_MODE_BANNER_DISMISSED_KEY) === this.bannerDismissalId) {
          this.showBanner = false;
        }
      },
    });
  }

  private get bannerDismissalId(): string {
    if (this.showDisabledBanner) {
      return 'disabled';
    }
    if (this.showExpireBanner) {
      return `expiring-${this.formattedDate}`;
    }
    return `enabled-${this.formattedDate}`;
  }

  private checkPilotModeExpiry(expiryDateUTC) {
    const expiryDate = new Date(expiryDateUTC);
    const today = new Date();
    return expiryDate < today;
  }

  private getExpiryDateAndDays(date) {
    const expiryIsoDate = date;
    const expiryDate = new Date(expiryIsoDate);
    const today = new Date();

    const timeDiff = expiryDate.getTime() - today.getTime();
    this.daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    if (this.daysRemaining == 2) {
      this.showEnabledBanner = false;
      this.showExpireBanner = true;
      this.showBanner = true;
    }
    const day = expiryDate.getDate().toString().padStart(2, '0');
    const month = (expiryDate.getMonth() + 1).toString().padStart(2, '0');
    const year = expiryDate.getFullYear();

    this.formattedDate = `${day}/${month}/${year}`;
  }
}
